<template lang="pug">

  .payment-form-container
    .card-number Reload Swipe Card {{ `#${card_barcode}` }}
    form(@submit.prevent='submit', @keydown='form.onKeydown($event)', novalidate='', :class="{ 'has-errors': form.errors.any() }")
      .alert.alert-danger(v-if='error') {{ error }}

      div(v-show="!reloaded")
        product-payment-form(:form="form", ref="productPaymentForm", :quantity-label="$t('reload.quantity')") It‘s easy! Choose an amount. Reload.

    modal(v-if="reloaded", @close="closeSuccessModal", container-class="wide")
      .v-modal-title Success!
      .v-modal-message Your Swipe Card has been reloaded.
        invoice-print(:invoice="invoice")
      .v-modal-buttons
        router-link.btn.btn-primary(:to="{ name: 'playcards.my' }") {{ $t('add_playcard.my_play_cards') }}

</template>

<script>
import Form from 'vform';
import { mapGetters } from 'vuex'

export default {
  name: 'reload-card',

  data: () => ({
    card_barcode: null,
    reloaded: false,
    error: null,
    form: new Form({
      product: {},
      cc_number: '',
      cc_expiration_year: '',
      cc_expiration_month: '',
      cc_code: '',
      cc_first_name: '',
      cc_last_name: '',
      billing_address: '',
      billing_city: '',
      billing_state: '',
      billing_zip: '',
      billing_country: '',
      location_id: null
    }),
    invoice: null
  }),

  computed: {
    ...mapGetters({
      user: 'authUser',
      authenticated: 'authCheck'
    })
  },

  created() {
    this.card_barcode = this.$router.currentRoute.params.barcode;

    if (this.authenticated) {
      this.form.location_id = this.user.preferred_location_id;
    }
  },

  methods: {
    async submit () {
      this.error = null;

      Object.assign(this.form.product, this.$store.state['pay/invoices'].products);

      this.form.cc_expiration_month = this.form._cc_expiration_month ? this.form._cc_expiration_month.value : null;
      this.form.cc_expiration_year = this.form._cc_expiration_year ? this.form._cc_expiration_year.value : null;

      const {data} = await this.form.post(`${window.addiesaas.url}/api/playcards/playcard/${this.card_barcode}/reload`);

      if (data && 'error' in data) {
        this.error = data.error;
      } else {
        this.invoice = data.invoice;

        this.$store.dispatch('clearProducts');

        this.reloaded = true;
      }
    },

    closeSuccessModal() {
      this.form.reset()
      this.error = null;
      this.$refs.productPaymentForm.updateTotal()
      this.reloaded = false
    }
  }
}
</script>
